module.exports = { // eslint-disable-line
  //URL: './api'
  URL: 'http://119.23.233.52:7777/api'
}



// WEBPACK FOOTER //
// ./src/api/config/_config_production.js